window.PH = window.PH || {};

PH.recommendation = {
  normalize(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  },

  productText(product) {
    return this.normalize([
      product.name,
      product.title,
      product.fullName,
      product.vendor,
      product.brand,
      product.tags,
      product.type,
      product.searchText,
      product.inspiredBy,
      product.family,
      product.gender,
      ...(product.moods || []),
      ...(product.occasions || []),
      ...(product.seasons || []),
      ...(product.notes || []),
      ...(product.taxonomy?.families || []),
      ...(product.taxonomy?.occasions || []),
      ...(product.taxonomy?.climates || []),
      ...(product.taxonomy?.moods || []),
      ...(product.taxonomy?.gender || [])
    ].join(' '));
  },

  scoreByIntent(product, intent) {
    if (!intent || !intent.weights) return 0;

    const text = this.productText(product);
    let score = 0;

    Object.keys(intent.weights).forEach(group => {
      const weights = intent.weights[group];

      Object.keys(weights).forEach(term => {
        const cleanTerm = this.normalize(term);

        if (text.includes(cleanTerm)) {
          score += weights[term];
        }
      });
    });

    if (product.available) score += 5;

    return score;
  },

  getReason(product, query) {
    const intent = PH.intents && typeof PH.intents.detect === 'function'
      ? PH.intents.detect(query)
      : null;

    if (!intent) return '';

    if (intent.id === 'cita') return '❤️ Ideal para cita';
    if (intent.id === 'oficina') return '✨ Ideal para oficina';
    if (intent.id === 'calor') return '☀️ Ideal para calor';
    if (intent.id === 'noche') return '🌙 Ideal para noche';
    if (intent.id === 'dulce') return '🍬 Perfil dulce';

    return `✨ Recomendado para ${intent.label}`;
  },

  enrich(product, query) {
    const intent = PH.intents && typeof PH.intents.detect === 'function'
      ? PH.intents.detect(query)
      : null;

    const recommendationScore = intent
      ? this.scoreByIntent(product, intent)
      : 0;

    return {
      ...product,
      recommendationScore,
      recommendationReason: this.getReason(product, query)
    };
  },

  filterResults(query, results) {
    const intent = PH.intents && typeof PH.intents.detect === 'function'
      ? PH.intents.detect(query)
      : null;

    if (!intent) {
      return results.map(item => this.enrich(item, query));
    }

    const enriched = results
      .map(item => this.enrich(item, query))
      .filter(item => item.recommendationScore >= (intent.minScore || 40))
      .sort((a, b) => b.recommendationScore - a.recommendationScore)
      .slice(0, intent.maxResults || 6);

    return enriched;
  }
};